import React, { useState, useMemo } from "react";
import AuctionNotice from "./AuctionNotice";
import PublicationNotice from "./PublicationNoice";
import TenderNotice from "./TenderNotice";
import PublicNotice from "./PublicNotice";

const Notices = () => {
  const [activeTab, setActiveTab] = useState("PublicNotice");

  const tabs = useMemo(
    () => [
      { id: "AuctionNotice", label: "AUCTION NOTICE", component: <AuctionNotice /> },
      { id: "PublicationNotice", label: "PUBLICATION NOTICE", component: <PublicationNotice /> },
      { id: "TenderNotice", label: "TENDER NOTICE", component: <TenderNotice /> },
      { id: "PublicNotice", label: "PUBLIC NOTICE", component: <PublicNotice /> },
    ],
    []
  );

  return (
    <div className="tender-bg">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* Tabs Navigation */}
            <ul
              className="nav d-flex justify-content-center"
              id="pills-tab-btm"
              role="tablist"
            >
              {tabs.map((tab) => (
                <li
                  className="nav-item"
                  role="presentation"
                  key={tab.id}
                >
                  <a
                    href={`#${tab.id}`}
                    role="tab"
                    id={`${tab.id}-tab`}
                    aria-controls={tab.id}
                    aria-selected={activeTab === tab.id}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab(tab.id);
                    }}
                    className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                  >
                    {tab.label}
                  </a>
                </li>
              ))}
            </ul>

            {/* Tab Content */}
            <div className="tab-content notices-sec" id="pills-tabContent">
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  className={`tab-pane fade ${activeTab === tab.id ? "show active" : ""}`}
                  id={tab.id}
                  role="tabpanel"
                  aria-labelledby={`${tab.id}-tab`}
                  tabIndex={0} // makes panels keyboard-focusable for accessibility
                >
                  {activeTab === tab.id && tab.component}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notices;
